import styled from "styled-components";

export const CardContainer = styled.div<{
  marginTop?: string;
  marginBottom?: string;
}>`
  background: #ffffff;
  border: 1px solid #eff0f6;
  box-shadow: 0px 5px 16px rgba(8, 15, 52, 0.06);
  border-radius: 34px;
  max-width: 709px;
  display: flex;
  width: 100%;
  padding: 35px;
  margin-top: ${(props) => props.marginTop || "0px"};
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  flex-direction: column;
`;
